export function yaasWalletQueryKey(address: string | undefined): readonly ["yaas", "wallet", string | undefined] {
    return ["yaas", "wallet", address] as const;
}
